import { PureComponent } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { InfoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
class HelpTooltip extends PureComponent {
  render() {
    const {
      iconProps,
      placement,
      title
    } = this.props;
    if (!title) {
      return null;
    }
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: placement,
      title: title,
      children: /*#__PURE__*/_jsx(IconHolder, Object.assign({}, iconProps, {
        color: "icon-core-subtle",
        icon: InfoIcon,
        padding: "0"
      }))
    });
  }
}
HelpTooltip.defaultProps = {
  iconProps: {}
};
export default HelpTooltip;